import { render } from "./HeartMonitor.vue?vue&type=template&id=4cefef60&scoped=true"
import script from "./HeartMonitor.vue?vue&type=script&lang=js"
export * from "./HeartMonitor.vue?vue&type=script&lang=js"

import "./HeartMonitor.vue?vue&type=style&index=0&id=4cefef60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cefef60"]])

export default __exports__